import { DisplayOption, FilterableMenuItem, FilterableMenuItemArgs } from 'owa-filterable-menu';
import { MonarchWin32Toggle } from 'native-newoutlook-toggle';
import * as React from 'react';

export function getNewOutlookToggle() {
    return new FilterableMenuItem({
        [FilterableMenuItemArgs.displayOption]: DisplayOption.Left,
        [FilterableMenuItemArgs.key]: 'newOutlookToggle',
        [FilterableMenuItemArgs.onRender]: () => {
            return <MonarchWin32Toggle />;
        },
    });
}
